import { BodyText, Card, Detail, Heading, InformationIcon, Separator } from '@farol-ds/react'
import { Image } from '@jusbrasil-web/shared-next-image'
import { sendMetrics } from '@jusbrasil-web/shared-utils-events'
import { useEffect } from 'react'

import { useModalContext } from '../context'
import styles from './one-click-success.module.scss'
import successImage from './success-image.svg'

export function OneClickSuccess() {
  const { oneClickSuccessData } = useModalContext()
  // FIXME: Remove this regex when the price text is fixed https://jusbrasil.slack.com/archives/C04M51BCC3V/p1763985081870189?thread_ts=1763675131.382309&cid=C04M51BCC3V. @gabrieldavib
  const wrongPriceTextRegex = /Seu plano passará de <b>(.*?)<\/b> para <b>(.*?)<\/b>/

  const presentationName = oneClickSuccessData?.offer.presentationName
  const priceText = oneClickSuccessData?.offer.priceText
  const frequency = oneClickSuccessData?.offer.frequency
  const frequencyInDays = oneClickSuccessData?.offer.frequencyInDays
  const isUpgrade =
    !!oneClickSuccessData?.viewer?.currentPlan?.orderCode &&
    !oneClickSuccessData?.viewer?.currentPlan?.isLoggedPlan

  const wrongPriceText = priceText?.match(wrongPriceTextRegex)
  const finalPriceText = wrongPriceText ? wrongPriceText[2] : priceText

  useEffect(() => {
    const pid = oneClickSuccessData?.lockEventProperties?.pid

    sendMetrics('UserAccount.OneClickSuccessViewed', pid?.toString(), {
      app_id: oneClickSuccessData?.lockEventProperties?.app_id,
      from_component: oneClickSuccessData?.lockEventProperties?.from_component,
      modal_type: oneClickSuccessData?.lockEventProperties?.modal_type,
      metadata: {
        presentationName,
        priceText,
        finalPriceText,
        frequency,
        frequencyInDays,
        isUpgrade:
          !!oneClickSuccessData?.viewer?.currentPlan?.orderCode &&
          !oneClickSuccessData?.viewer?.currentPlan?.isLoggedPlan,
      },
    })
  }, [oneClickSuccessData, presentationName, priceText, frequency, frequencyInDays, finalPriceText])

  const getCartTitle = () => {
    if (isUpgrade) {
      return 'Atualização de pagamento recorrente'
    }
    return 'Pagamento recorrente'
  }

  const getCartDescription = () => {
    if (isUpgrade) {
      return 'O valor cobrado hoje compensa o período não utilizado da assinatura atual. O valor será integral a partir da próxima cobrança.'
    }
    return `Cobrança a cada ${frequencyInDays} dias. Cancele quando quiser.`
  }

  return (
    <div className={styles.oneClickSuccess} data-testid="one-click-success">
      <div className={styles.oneClickSuccessContainer}>
        <div className={styles.oneClickSuccessFeedback}>
          <Image src={successImage} alt="sucesso" />
          <Heading size="xl">Compra realizada com sucesso</Heading>
        </div>
        <Card className={styles.oneClickSuccessSummary}>
          <div className={styles.oneClickSuccessSummaryItemPriceDetails}>
            <Heading size="sm">Plano {presentationName}</Heading>
            {priceText && frequency && (
              <BodyText>
                {finalPriceText} / {frequency}
              </BodyText>
            )}
          </div>
          <Separator />
          <Detail>
            <Detail.Icon>
              <InformationIcon />
            </Detail.Icon>
            <Detail.Label>{getCartTitle()}</Detail.Label>
            <Detail.Value>{getCartDescription()}</Detail.Value>
          </Detail>
        </Card>
      </div>
    </div>
  )
}
